import {Component} from "react"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import environmentVariables from "shared/enviromentVariables/index.js.erb"
import {connect} from "react-redux"
import {isOpenRemunerationPlan} from "shared/plans"

class Footer extends Component {
  render(){
    const openRemUser = isOpenRemunerationPlan(this.props.current_user)
    return(
      <footer className="page-footer font-small mdb-color pt-4 mt-5">
        <Container>
          <Row className="d-flex first-section">
            <div style={{flex: 0.35}}>
              <small>
                Application built by&nbsp;
                <a href={environmentVariables.company_website} target="_blank">
                  {environmentVariables.company_name}
                </a>
              </small>
            </div>
            <div style={{flex: 0.35}}>
              <small>
                Researcher? Contact us @&nbsp;
                {!openRemUser &&
                <a href={`mailto:${environmentVariables.info_email}`}>
                  {environmentVariables.info_email}
                </a>
                }
                {openRemUser &&
                <a href={`mailto:${environmentVariables.open_rem_email}`}>
                  {environmentVariables.open_rem_email}
                </a>
                }
              </small>
            </div>
            <div style={{flex: 0.10}}>
              <small>
                <a href="#" className="" onClick={() => window.open('/methodology.pdf', '_blank')}>Methodology</a>
              </small>
            </div>
            <div style={{flex: 0.10}}>
              <small>
                <a href="#" className="" onClick={() => window.open('/privacy-policy.pdf', '_blank')}>Privacy Policy</a>
              </small>
            </div>
            <div style={{flex: 0.10}}>
              <small>
                <a href="#" className="" onClick={() => window.open('/terms.pdf', '_blank')}>Terms of Services</a>
              </small>
            </div>
          </Row>

          <Row className="d-flex align-items-center">
            <div className='mb-3'>
              {!openRemUser &&
              <small>
                {environmentVariables.app_name} © {new Date().getFullYear()}
              </small>
              }
              {openRemUser &&
              <small>
                {environmentVariables.open_rem_app_name} © {new Date().getFullYear()}
              </small>
              }
            </div>
          </Row>
        </Container>
      </footer>
    )
  }
}

function mapStateToProps(state) {
  const { users } = state;

  return {
    current_user: users.user
  }
}

export default connect(mapStateToProps, null)(Footer)
